/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeCurrentUserProfile.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Current User Profile Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:37 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const CURRENTUSERPROFILE_EDIT_CONTAINER_LOADED = 'CURRENTUSERPROFILE_EDIT_CONTAINER_LOADED';
export const CURRENTUSERPROFILE_EDIT_CONTAINER_UNLOADED = 'CURRENTUSERPROFILE_EDIT_CONTAINER_UNLOADED';
export const CURRENTUSERPROFILE_EDIT_FORM_LOADED = 'CURRENTUSERPROFILE_EDIT_FORM_LOADED';
export const CURRENTUSERPROFILE_EDIT_FORM_UNLOADED = 'CURRENTUSERPROFILE_EDIT_FORM_UNLOADED';
export const CURRENTUSERPROFILE_UPDATE_FIELD = 'CURRENTUSERPROFILE_UPDATE_FIELD';
export const CURRENTUSERPROFILE_EDIT_FORM_SUBMIT = 'CURRENTUSERPROFILE_EDIT_FORM_SUBMIT';
export const CURRENTUSERPROFILE_EDIT_FORM_CANCEL = 'CURRENTUSERPROFILE_EDIT_FORM_CANCEL';
export const CURRENTUSERPROFILE_OPEN_GENERATE_PASSWORD = 'CURRENTUSERPROFILE_OPEN_GENERATE_PASSWORD';
export const CURRENTUSERPROFILE_CLOSE_GENERATE_PASSWORD = 'CURRENTUSERPROFILE_CLOSE_GENERATE_PASSWORD';
export const CURRENTUSERPROFILE_OPEN_GENERATE_PASSWORD_RESULTS = 'CURRENTUSERPROFILE_OPEN_GENERATE_PASSWORD_RESULTS';
export const CURRENTUSERPROFILE_CLOSE_GENERATE_PASSWORD_RESULTS = 'CURRENTUSERPROFILE_CLOSE_GENERATE_PASSWORD_RESULTS';


// WEBPACK FOOTER //
// ./src/constants/actionTypeCurrentUserProfile.js